import React, {useState, useEffect} from "react";
import {Layout, IconHeader} from "components";
import {Button, Row, Col} from "react-bootstrap";
import {
  getServiceLinks,
  existedAppointmentBooking
} from "services/api-service";
import {useParams, useNavigate} from "react-router-dom";
import {useSelector, useDispatch, batch} from "react-redux";
import "../style.scss";

import {
  APPOINTMENT,
  APPOINTMENT_EXISTENCE,
  SERVICE_CHANNEL
} from "constants/route";
import {
  BackButton,
  Instruction,
  LinkButton,
  SeparatorLine
} from "components/CommonUI";

import {getSubService, getService} from "services/api-service";
import {changeSubServiceInfo, changeIconAndMainWebText} from "redux/services";
import _ from "lodash";

import {
  changeEnquiryId,
  updateAppointmentInfo,
  changeAge,
  changeNric
} from "redux/appointment";
import {
  updateAppointmentBookingInfo,
  changePreviousRouteName
} from "redux/appointmentBooking";
import {changeOtpAppointmentExistence, updateServices} from "redux/services";
import axios from "axios";
import {env} from "../env";

// Non CRPS
// Non E-xperience
const NormalPage = ({id, goAppointment}) => {
  const {mainId, displayText, icon} = useSelector((state) => state.services);

  const [serviceLinks, setServiceLinks] = useState({});

  const getServiceLink = async (mainId, id) => {
    const data = await getServiceLinks(mainId, id);
    data.data && setServiceLinks(data.data);
  };

  useEffect(() => {
    mainId && id && getServiceLink(mainId, id);
  }, [mainId, id]);

  const handleGoToLink = (url) => window.open(url, "_blank");

  return (
    <div className="form-box">
      {/* <div className="center text-secondary mt-3"></div> */}

      <div className="center row mt-3">

        <div className="center text-secondary">
          <IconHeader icon={icon} title={displayText}/>
          <div className="offset-md-1 col-md-10">
            <br/>
            <div className="center text-secondary mt-3">

              <a
                className="cmp-button cmp-button--link"
                onClick={goAppointment}
                rel="noreferrer"
              >
              <span className="cmp-button__text">
                {/* Connect with our Customer Service Executives */}
                Make an appointment
              </span>
                <span class="icons_space icon-dls-arrow-right" style={{marginTop:-6}}></span>
              </a>
            </div>
            <br/>
            <SeparatorLine/>


            <div
              className="sub-header-label-x px-4"
              style={{
                marginTop: 15,
                textAlign: "left"
                // color: "rgb(33, 37, 41)"
              }}
            >
              Answers to your queries might be found more swiftly in our FAQs. Do consider them before making an appointment.
            </div>

            <div className="mt-3">
              {serviceLinks?.data?.webLinks.map(
                ({id, description_name, url}) => (
                  <div
                    key={id}
                    style={{
                      // paddingBottom: 20,
                      textAlign: "left",
                      paddingLeft: 16,
                      paddingRight: 16
                    }}
                  >
                    <ul style={{marginBottom: 0, color: "#262626"}}>
                      <li style={{listStyle: "disc"}}>
                        <a
                          className="cmp-button cmp-button--link"
                          href={`${url}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span className="cmp-button__text">
                            {description_name}
                          </span>
                        </a>
                      </li>
                    </ul>
                    <br/>
                  </div>
                )
              )}
            </div>
            <div>
              {serviceLinks?.data?.mediaLinks.map(
                ({id, description_name, url}) => (
                  <div
                    key={id}
                    style={{
                      // paddingBottom: 20,
                      textAlign: "left",
                      paddingLeft: 16
                    }}
                  >
                    <ul style={{marginBottom: 0, color: "#262626"}}>
                      <li style={{listStyle: "disc"}}>
                        <a
                          className="cmp-button cmp-button--link"
                          href={`${url}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span className="cmp-button__text">
                            {description_name}
                          </span>
                        </a>
                      </li>
                    </ul>
                    <br/>
                  </div>
                )
              )}
            </div>

            {serviceLinks?.data?.buttonLinks.length > 0 && (
              <>
                <SeparatorLine/>
                <div className="mt-3 sub-header-label-x">
                  Here are other related topics that you might find useful
                </div>
              </>
            )}

            <div
              style={{
                display: "flex",
                // border: "1px solid red",
                justifyContent: "center"
              }}
              className={"mobile-flex"}
            >
              <>
                {serviceLinks?.data?.buttonLinks.map(
                  ({id, description_name, url}) => (
                    <LinkButton
                      key={id}
                      text={description_name}
                      onClick={() => handleGoToLink(url)}
                      style={{flexGrow: 1}}
                    />
                  )
                )}
                {/* <LinkButton
                    key={id}
                    text={"test"}
                    onClick={() => handleGoToLink("")}
                  /> */}
              </>
            </div>
          </div>


        </div>
      </div>
      <div className="form-footer">
        <BackButton/>
      </div>
    </div>
  );
};

const CrpsPage = ({goAppointment}) => {
  const {displayText, icon} = useSelector((state) => state.services);

  const handleGoToLink = (url) => window.open(url, "_blank");

  return (
    <div className="form-box">
      <div className="center row mt-3">
        <div className="offset-md-1 col-md-10">
          <div className="center text-secondary">
            <IconHeader icon={icon} title={displayText}/>

            <div
              style={{marginTop: 40, textAlign: "left"}}
              className={"px-4"}
            >
              The CPF Retirement Planning Service (CRPS) provides members with
              personalised retirement planning information to enable them to
              better understand and take actions to benefit from their CPF.{" "}
              <br/>
              The service is available to members: <br/>
              (i) reaching 55, or <br/>
              (ii) reaching or have reached 65.
              <br/>
              <br/>
              <a
                className="cmp-button cmp-button--link"
                rel="noreferrer"
                onClick={goAppointment}
              >
                <span className="cmp-button__text">
                  Book a CRPS appointment
                </span>
              </a>
            </div>
            <div style={{marginTop: 30}} className={"px-4"}>
              <p style={{textAlign: "left"}}>
                You may also view your personalised retirement planning
                information through the links below. <br/>
              </p>
            </div>

            <ul className={"px-4"}>
              <li>
                <div style={{textAlign: "left"}}>
                  <a
                    className="cmp-button cmp-button--link"
                    href={window.crpsAge55Link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="cmp-button__text">
                      If you are reaching 55
                    </span>
                  </a>
                </div>
              </li>
              <li>
                <div style={{textAlign: "left"}}>
                  <a
                    className="cmp-button cmp-button--link"
                    href={window.crpsAge65Link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="cmp-button__text">
                      If you are reaching or have reached 65{" "}
                    </span>
                  </a>
                </div>
              </li>
            </ul>

            <SeparatorLine/>
            <div>Here are other related topics that you might find useful</div>
            <div
              style={{
                display: "flex",
                // border: "1px solid red",
                justifyContent: "center"
              }}
              className={"mobile-flex"}
            >
              <LinkButton
                text={"Withdraw for immediate needs"}
                onClick={() => handleGoToLink(window.crpsButton1Link)}
                style={{flexGrow: 1}}
              />
              <LinkButton
                text={"CPF LIFE & monthly payouts"}
                onClick={() => handleGoToLink(window.crpsButton2Link)}
                style={{flexGrow: 1}}
              />
              <LinkButton
                text={"Make a CPF nomination"}
                onClick={() => handleGoToLink(window.crpsButton3Link)}
                style={{flexGrow: 1}}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="form-footer">
        <BackButton/>
      </div>
    </div>
  );
};

const ExperiencePage = ({id, goAppointment}) => {
  const {mainId, displayText, icon} = useSelector((state) => state.services);
  const [serviceLinks, setServiceLinks] = useState({});

  const getServiceLink = async (mainId, id) => {
    const data = await getServiceLinks(mainId, id);
    data.data && setServiceLinks(data.data);
  };

  useEffect(() => {
    mainId && id && getServiceLink(mainId, id);
  }, [mainId, id]);

  const handleGoToLink = (url) => window.open(url, "_blank");

  const listStyle = {listStyle: "disc"};

  return (
    <div className="form-box">
      <div className="center row mt-3">
        <div className="offset-md-1 col-md-10">
          <div className="center text-secondary">
            <IconHeader icon={icon} title={displayText}/>

            <div
              style={{marginTop: 40, textAlign: "left"}}
              className={"px-4"}
            >
              CPFB’s E-Xperience Workshop is a 30-min session conducted in a
              group setting where our officers/CPF volunteers will guide you on
              how to use your own mobile device to transact digitally with us.
              Please bring along your smartphone to the E-Xperience Workshop.
              <br/>
              <br/>
              We will guide you on how to: <br/>
              <ul>
                <li style={listStyle}>
                  Set up and use the Singpass Mobile App
                </li>
                <li style={listStyle}>View and download your CPF Statements</li>
                <li style={listStyle}>Submit CPF withdrawal applications</li>
                <li style={listStyle}>Top-up your CPF Accounts</li>
              </ul>
              <br/>
              <a
                className="cmp-button cmp-button--link"
                rel="noreferrer"
                onClick={goAppointment}
              >
                <span className="cmp-button__text">Book an E-Xperience Workshop</span>
              </a>
            </div>
            {/* <div style={{ marginTop: 30 }} className={"px-4"}>
              <Instruction>
                <div style={{ textAlign: "left" }}>
                  Note: The workshop will be conducted in English. However,
                  should there be officers who could converse in your preferred
                  language, they will be glad to assist you along.
                </div>
              </Instruction>
            </div> */}

            {serviceLinks?.data?.buttonLinks.length > 0 && (
              <>
                <SeparatorLine/>
                <div>You might also be interested in the related topics:</div>
                <div
                  style={{
                    display: "flex",
                    // border: "1px solid red",
                    justifyContent: "center"
                  }}
                  className={"mobile-flex"}
                >
                  {serviceLinks?.data?.buttonLinks.map(
                    ({id, description_name, url}) => (
                      <LinkButton
                        key={id}
                        text={description_name}
                        onClick={() => handleGoToLink(url)}
                        style={{flexGrow: 1}}
                      />
                    )
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="form-footer">
        <BackButton/>
      </div>
    </div>
  );
};

export default function ServiceDetail() {
  const dispatch = useDispatch();
  const {mainId, isCrps, isExperience} = useSelector(
    (state) => state.services
  );
  const {nric} = useSelector((state) => state.appointment);
  const {isLogin} = useSelector((state) => state.signPassIdentify);
  const {id, mid} = useParams();

  const navigate = useNavigate();

  const goAppointment = async () => {
    let res = null;
    if (isLogin) {
      res = await existedAppointmentBooking(nric);
      if (!_.isEmpty(res.data)) {
        const data = res.data;
        batch(() => {
          dispatch(updateAppointmentInfo(data));
          dispatch(updateAppointmentBookingInfo(data));
          dispatch(updateServices(data));
        });

        navigate(APPOINTMENT_EXISTENCE, {
          replace: true
        });
        dispatch(
          changeOtpAppointmentExistence({
            mainId: data.service_id,
            subServiceId: data.sub_service_id,
            mainWebDisplayText: data.scheme
          })
        );
        return;
      }
    }

    // Not Login
    if (isExperience) {
      dispatch(changeEnquiryId(1));
      dispatch(changeAge("1902"));
      dispatch(changePreviousRouteName("/appointment"));
      navigate(SERVICE_CHANNEL);
      return;
    }
    // Normal or crps, not experience

    !isCrps && dispatch(changeAge(""));
    navigate(APPOINTMENT);
  };

  // Re-fetch main service if its not in store,
  // might be coming from direct url
  useEffect(() => {
    console.log("mainId", mainId, mid, id);
    if (!mainId && mid) {
      console.log("mainId fetch main service");
      getService().then(({data: service}) => {
        const mainService = service.data.find(
          (x) => x.id === parseInt(mid, 10)
        );
        dispatch(
          changeIconAndMainWebText({
            icon: mainService.icon_uuid,
            mainWebDisplayText: mainService.web_disp_text
          })
        );
      });
    }
  }, [mainId, mid]);

  // Re-fetch main service if its not in store,
  // might be coming from direct url
  useEffect(() => {
    if (!mainId && mid && id) {
      getSubService(mid).then(({data: subService}) => {
        const subServiceObj = subService.data.find(
          (x) => x.id === parseInt(id, 10)
        );
        dispatch(
          changeSubServiceInfo({
            mainId: mid,
            subServiceId: parseInt(id, 10),
            displayText: subServiceObj.web_disp_text,
            isCrps: subServiceObj.is_crps,
            isExperience: subServiceObj.is_experience
          })
        );
      });
    }
  }, [mainId, mid, id]);

  return (
    <Layout subHeader={"How can we help?"}>
      {!isCrps && !isExperience && (
        <NormalPage id={id} goAppointment={goAppointment}/>
      )}
      {isCrps && <CrpsPage goAppointment={goAppointment}/>}
      {isExperience && <ExperiencePage id={id} goAppointment={goAppointment}/>}
    </Layout>
  );
}
